import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAttachment = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26.1 26.1",
	enableBackground: "new 0 0 26.1 26.1",
	width: "512px",
	height: "512px",
	className: "",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M9.7,17.7c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3l9.2-9.2c0.1-0.1,0.3-0.3,0.7-0.3c0.6,0,1,0.4,1,1  c0,0.3-0.1,0.5-0.3,0.7L10.8,20.8c-1.5,1.5-4.1,1.5-5.7,0C4.3,20,3.9,19,3.9,18s0.4-2.1,1.2-2.8L17.2,3.1c0.4-0.4,0.4-1,0-1.4  l-1.4-1.4C15.6,0.1,15.4,0,15.1,0s-0.5,0.1-0.7,0.3L2.3,12.4C0.8,13.9,0,15.9,0,18.1s0.8,4.1,2.3,5.7c1.5,1.5,3.5,2.3,5.7,2.3  s4.1-0.8,5.7-2.3l10.9-10.9c0.9-0.9,1.5-2.2,1.5-3.5c0-2.8-2.2-5-5-5c-1.3,0-2.6,0.5-3.5,1.5l-9.2,9.2c-0.4,0.4-0.4,1,0,1.4  L9.7,17.7z",
		className: "active-path",
		fill: "#2AA3BB"
	}) })
});
export default SvgAttachment;
